import React, { useEffect } from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { makeStyles } from '@material-ui/core/styles';
import { fetchIdeas, fetchIdea } from '@/actions/idea';
import Main from '@/layouts/Main';
import DetailImageContainer from '@/containers/ideas/DetailImageContainer';
import DetailTitleContainer from '@/containers/ideas/DetailTitleContainer';
import BottomBanner from '@/components/common/BottomBanner';
import Head from '@/components/common/Head';
import DetailArticle from '@/components/ideas/DetailArticle';
import DetailQuote from '@/components/ideas/DetailQuote';
import DetailAuthor from '@/components/ideas/DetailAuthor';
import DetailPaging from '@/components/ideas/DetailPaging';
import ShoppingCarouselList from '@/components/shoppings/ShoppingCarouselList';
import styles from 'styles/jss/original/pages/ideas/slug';
import { IDEA_RELATION_SHOPPING } from '@/constants/app';
import { SITE_TITLE, SITE_DESCRIPTION } from '@/config/meta';
import _ from 'lodash';
import basicAuthentication from '@/lib/basicAuthentication';
import useIdeaDetail from '@/hooks/useIdeaDetail';
import { wrapper, AppDispatch } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const IdeaPost: NextPage = () => {
  const classes = useStyles();
  const [idea, ideaList, shoppingList, error] = useIdeaDetail();
  const router = useRouter();
  useEffect(() => {
    if (error) {
      _.defer(() => router.replace('/404'));
    }
  }, [error, router]);
  if (error || !idea) return null;
  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={`${idea.fields.title} | ${SITE_TITLE}`}
          description={`${idea.fields.desc} | ${SITE_DESCRIPTION}`}
          image={`https:${idea.fields.mainImage.fields.file.url}`}
          url={`https://smalldish.jp/ideas/${idea.fields.slug}`}
        />
        <div className={classes.main}>
          <DetailTitleContainer idea={idea} />
          <DetailImageContainer idea={idea} />
          <DetailArticle idea={idea} />
          <DetailQuote idea={idea} />
          <DetailAuthor idea={idea} />
          <DetailPaging idea={idea} ideaList={ideaList} />
          <ShoppingCarouselList title={IDEA_RELATION_SHOPPING} shoppingList={shoppingList} />
          <BottomBanner />
        </div>
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ query, store, req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
  await Promise.all([
    (store.dispatch as AppDispatch)(fetchIdeas()),
    (store.dispatch as AppDispatch)(fetchIdea(query.slug))
  ]);
});

export default IdeaPost;
